// extracted by mini-css-extract-plugin
export default {"page":"Home_page__P1kJB","konten":"Home_konten__HKF-b","category":"Home_category__RQHOG","orderContainer":"Home_orderContainer__ot002","orderCard":"Home_orderCard__rFTrl"};